// 第三方供应商表格表头
export let thirdVendorsLabels = [
  {
    label: '供应商名称',
    value: 'name'
  },
  {
    label: '类型',
    value: 'vender_type'
  },
  {
    label: '商品数量（个）',
    value: 'goodsNumber'
  },
  {
    label: '联系人',
    value: 'base.contact'
  },
  {
    label: '联系人电话',
    value: 'base.mobile'
  }
]
// 选择商品的列表顶部筛选
export let couponGoodsLabs = [
  {
    label: '类型',
    type: 'select',
    clearable: true,
    value: 'type', // 需返回数据的字段名
    options: []
  }
]
